// The query client: data lives in memory only (plan section E, "Data on the device"); nothing is persisted.
import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api.ts'

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        // A 4xx answer is final (404 is also the answer for a foreign id); only transient failures retry.
        retry: (count, error) => !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
      },
      mutations: { retry: false },
    },
  })
}
